(() => {
  'use strict';


  const gallerySelector = 'body.template-product #MainContent .productView-nav';
  const guardedGalleries = new WeakSet();
  function focusGallery(gallery) {
    const list = gallery.querySelector('.slick-list');
    if (!list || Number(gallery.dataset.mediaCount || 0) < 2) return;
    if (!guardedGalleries.has(gallery)) {
      guardedGalleries.add(gallery);
      gallery.addEventListener('click', event => {
        if (gallery.slick?.shouldClick === false) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);
    }
    if (list.tabIndex !== 0) list.tabIndex = 0;
    if (list.getAttribute('role') !== 'group') list.setAttribute('role', 'group');
    const title = document.querySelector('body.template-product #MainContent .productView-title');
    if (title && list.getAttribute('aria-label') !== title.textContent.trim()) list.setAttribute('aria-label', title.textContent.trim());
  }
  if (window.jQuery) {
    const pending = new WeakSet();
    window.jQuery(document).on('init.skRoseGallery reInit.skRoseGallery breakpoint.skRoseGallery setPosition.skRoseGallery', gallerySelector, function () {
      const gallery = this;
      if (pending.has(gallery)) return;
      pending.add(gallery);
      queueMicrotask(() => {
        pending.delete(gallery);
        if (gallery.isConnected) focusGallery(gallery);
      });
    });
  }

  function initialize(scope = document) {
    scope.querySelectorAll(gallerySelector).forEach(focusGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

(() => {
  'use strict';
  const selector = 'body.template-product #MainContent #judgeme_product_reviews';
  const states = new WeakMap();
  let sequence = 0;

  function decorate(widget) {
    widget.querySelectorAll('.jdgm-rev .jdgm-row-extra,.jdgm-rev .jdgm-rev__custom-form,.jdgm-rev .jdgm-rev__actions').forEach(block => {
      const empty = !block.textContent.trim() && !block.querySelector('img,video,a,button,input,select,textarea,svg');
      if (block.classList.contains('sk-pe-empty') !== empty) block.classList.toggle('sk-pe-empty', empty);
    });
    widget.querySelectorAll('.jdgm-histogram__row[data-percentage]').forEach(row => {
      const value = Number(row.getAttribute('data-percentage'));
      if (!Number.isFinite(value) || value < 0 || value > 100) return;
      const height = value + '%';
      if (row.style.getPropertyValue('--sk-pe-percent') !== height) row.style.setProperty('--sk-pe-percent', height);
    });
    const count = Number(widget.querySelector('.jdgm-rev-widg')?.getAttribute('data-number-of-reviews'));
    const actions = widget.querySelector('.jdgm-row-actions');
    if (actions && Number.isInteger(count) && count >= 0) {
      let label = actions.querySelector('.sk-pe-review-count');
      if (!label) {
        label = document.createElement('span');
        label.className = 'sk-pe-review-count';
        actions.prepend(label);
      }
      const text = count + (count === 1 ? ' review' : ' reviews');
      if (label.textContent !== text) label.textContent = text;
    }
    const paginate = widget.querySelector('.jdgm-paginate');
    if (!paginate) return;
    const page = Number(paginate.querySelector('.jdgm-curt')?.getAttribute('data-page'));
    const displayed = Math.min(4, widget.querySelectorAll('.jdgm-rev-widg__reviews > .jdgm-rev').length);
    if (!Number.isInteger(page) || page < 1 || !displayed || !Number.isInteger(count) || count < 0) return;
    let range = paginate.querySelector('.sk-pe-page-range');
    if (!range) {
      range = document.createElement('span');
      range.className = 'sk-pe-page-range';
      paginate.prepend(range);
    }
    const clear = widget.querySelector('.jdgm-histogram__clear-filter');
    const filtered = clear && getComputedStyle(clear).display !== 'none';
    const start = (page - 1) * 4 + 1;
    const text = filtered ? displayed + ' reviews shown' : start + '–' + (start + displayed - 1) + ' of ' + count;
    if (range.textContent !== text) range.textContent = text;
  }

  function configure(widget, state) {
    const $ = window.jdgm?.$;
    if (typeof $ !== 'function') return false;
    const nativeWidget = $(widget);
    widget.querySelectorAll('.jdgm-paginate').forEach(paginator => {
      if (paginator.getAttribute('data-per-page') !== '4') paginator.setAttribute('data-per-page', '4');
      if ($(paginator).data('per-page') !== 4) $(paginator).data('per-page', 4);
    });
    if (state.initialized) return true;
    const dropdown = widget.querySelector('.jdgm-rev-widg__sort-wrapper .jdgm-sort-dropdown');
    if (!dropdown || !Array.from(dropdown.options).some(option => option.value === 'pictures-first')) return false;
    if (!['before-callback', 'success-callback', 'extra-params-getter'].every(key => typeof nativeWidget.data(key) === 'function')) return false;
    if (!widget.querySelector('.jdgm-paginate')) return false;
    state.initialized = true;
    clearTimeout(state.retry);
    state.retry = 0;
    const oldScroll = nativeWidget.data('not-scroll-to');
    const namespace = '.skPhotoEditorial' + (++sequence);
    const productId = String(widget.getAttribute('data-id') || widget.getAttribute('data-product-id') || '');
    const nativeDocument = $(document);
    const restore = () => {
      clearTimeout(state.cleanupTimer);
      state.cleanupTimer = 0;
      nativeDocument.off('ajaxComplete' + namespace);
      widget.removeEventListener('click', onInteraction, true);
      widget.removeEventListener('change', onInteraction, true);
      if (oldScroll === undefined) nativeWidget.removeData('not-scroll-to');
      else nativeWidget.data('not-scroll-to', oldScroll);
      state.restore = null;
    };
    const onInteraction = event => {
      if (event.isTrusted && event.target instanceof Element && event.target.closest('.jdgm-sort-dropdown,.jdgm-paginate__page,.jdgm-histogram__star,.jdgm-histogram__clear-filter')) restore();
    };
    state.restore = restore;
    nativeWidget.data('not-scroll-to', true);
    nativeDocument.on('ajaxComplete' + namespace, (event, xhr, settings) => {
      if (!settings?.url || !String(settings.url).includes('/reviews/reviews_for_widget')) return;
      let params;
      try { params = new URL(settings.url, location.href).searchParams; }
      catch (error) { return; }
      const data = typeof settings.data === 'string' ? new URLSearchParams(settings.data) : new URLSearchParams(settings.data || {});
      data.forEach((value, key) => params.set(key, value));
      if (params.get('product_id') === productId && params.get('per_page') === '4' && params.get('sort_by') === 'pictures_first') restore();
    });
    widget.addEventListener('click', onInteraction, true);
    widget.addEventListener('change', onInteraction, true);
    state.cleanupTimer = setTimeout(restore, 15000);
    try {
      $(dropdown).val('pictures-first').trigger('change');
    } catch (error) {
      restore();
      state.initialized = false;
    }
    return state.initialized;
  }

  function refresh(widget, state) {
    if (!widget.isConnected) {
      state.observer.disconnect();
      clearTimeout(state.retry);
      state.restore?.();
      return;
    }
    decorate(widget);
    if (configure(widget, state) || state.retry || state.attempts >= 50) return;
    state.retry = setTimeout(() => {
      state.retry = 0;
      state.attempts++;
      refresh(widget, state);
    }, 200);
  }

  function initialize(scope = document) {
    scope.querySelectorAll(selector).forEach(widget => {
      let state = states.get(widget);
      if (!state) {
        state = {initialized:false, pending:false, retry:0, attempts:0, cleanupTimer:0, restore:null, observer:null};
        state.observer = new MutationObserver(() => {
          if (state.pending) return;
          state.pending = true;
          queueMicrotask(() => {
            state.pending = false;
            refresh(widget, state);
          });
        });
        state.observer.observe(widget, {childList:true, subtree:true, attributes:true, attributeFilter:['data-number-of-reviews','data-average-rating','data-percentage','data-per-page']});
        states.set(widget, state);
      }
      refresh(widget, state);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), {once:true});
  else initialize();
  document.addEventListener('jdgm.doneSetup', () => initialize());
  document.addEventListener('jdgm.doneCustomizeReviews', () => queueMicrotask(() => initialize()));
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll(selector).forEach(widget => {
      const state = states.get(widget);
      if (!state) return;
      state.observer.disconnect();
      clearTimeout(state.retry);
      state.restore?.();
    });
  });
})();




(() => {
  'use strict';
  let frame = 0;
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const summary = event.target.closest('.sk-sc-chapters > .sk-sc-chapter > summary');
    if (!summary) return;
    if (frame) cancelAnimationFrame(frame);
    frame = 0;
    const chapter = summary.parentElement;
    if (chapter.open || event.defaultPrevented) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      if (event.defaultPrevented || !chapter.isConnected || !chapter.open) return;
      const headerHeight = Array.from(document.querySelectorAll('.shopify-section-group-header-group'))
        .reduce((height, header) => {
          const position = getComputedStyle(header).position;
          return position === 'sticky' || position === 'fixed' ? height + header.offsetHeight : height;
        }, 0);
      summary.style.setProperty('--sk-sc-header-clearance', (headerHeight + 12) + 'px');
      summary.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'instant' });
    });
  }, true);
})();


